/**
 * @Date:   2018-01-22T12:36:23+08:00
 * @Last modified time: 2018-02-05T20:17:19+08:00
 */
import _util from '../../utils/';

const roleManagementService = {
    fetchRoleList(params, resolve, reject) {
        _util.request({
            url: '/api/HRRole/Get',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchRoleInit(resolve, reject) {
        _util.request({
            url: '/api/HRRole/Create',
            success: resolve,
            error: reject
        })
    },
    createNewRole(roleInfo, resolve, reject) {
        _util.request({
            url: '/api/HRRole/Create',
            method: 'POST',
            data: roleInfo,
            success: resolve,
            error: reject
        })
    },
    deleteRoles(roleIds, resolve, reject) {
        _util.request({
            url: '/api/HRRole/MultiDelete',
            method: 'DELETE',
            data: roleIds,
            success: resolve,
            error: reject
        })
    },
    fetchRoleDetail(params, resolve, reject) {
        _util.request({
            url: '/api/HRRole/Detail',
            params: params,
            success: resolve,
            error: reject
        })
    },
    updateRole(payload, resolve, reject) {
        _util.request({
            url: '/api/HRRole/Update',
            method: 'PUT',
            data: payload,
            success: resolve,
            error: reject
        })
    }
}

export default roleManagementService;



// WEBPACK FOOTER //
// ./src/services/SystemSetting/role-management-service.js